import { IEditCredentialsContext } from './editCredentialsContext';

export enum EditCredentialsActionTypes {
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	REFETCH_DATA = 'REFETCH_DATA',
	CHANGE_CREDENTIAL_NAME = 'CHANGE_CREDENTIAL_NAME',
	CHANGE_API_KEY = 'CHANGE_API_KEY',
	CHANGE_API_SECRET = 'CHANGE_API_SECRET',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface ISetInitialFormData {
	type: EditCredentialsActionTypes.SET_INITIAL_FORM_DATA;
	payload: {
		initialFormData: IEditCredentialsContext['initialFormData'];
	};
}

interface ISetAllData {
	type: EditCredentialsActionTypes.SET_ALL_DATA;
	payload: {
		credentialID: IEditCredentialsContext['credentialID'];
		credentialType: IEditCredentialsContext['credentialType'];
		credentialName: IEditCredentialsContext['credentialName'];
		apiKey: IEditCredentialsContext['apiKey'];
		apiSecret: IEditCredentialsContext['apiSecret'];
	};
}

interface IRefetchData {
	type: EditCredentialsActionTypes.REFETCH_DATA;
	payload: {
		needRefetchData: IEditCredentialsContext['needRefetchData'];
	};
}

interface IChangeCredentialName {
	type: EditCredentialsActionTypes.CHANGE_CREDENTIAL_NAME;
	payload: {
		credentialName: IEditCredentialsContext['credentialName'];
	};
}

interface IChangeApiKey {
	type: EditCredentialsActionTypes.CHANGE_API_KEY;
	payload: {
		apiKey: IEditCredentialsContext['apiKey'];
	};
}

interface IChangeApiSecret {
	type: EditCredentialsActionTypes.CHANGE_API_SECRET;
	payload: {
		apiSecret: IEditCredentialsContext['apiSecret'];
	};
}

interface ISetDataForSubmit {
	type: EditCredentialsActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IEditCredentialsContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: EditCredentialsActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IEditCredentialsContext['typeOfModalWindow'];
	};
}

interface IResetSelectedControls {
	type: EditCredentialsActionTypes.RESET_FIELDS;
}

export type TEditCredentialsAction =
	| ISetInitialFormData
	| ISetAllData
	| IRefetchData
	| IChangeCredentialName
	| IChangeApiKey
	| IChangeApiSecret
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IResetSelectedControls;
